export default __webpack_public_path__ + "conveyor-belt.png?b0fa8c2836b96ac02d3f8923717fd4f6";